// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"9d387756","453":"5829070d"}[chunkId] + ".chunk.js";
};